import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "dialog"]
  static values = { open: Boolean }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    this.syncPanel()
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.body.style.overflow = ""
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close(event)
  }

  open(event) {
    event?.preventDefault()
    this.openValue = true
  }

  close(event) {
    event?.preventDefault()
    this.openValue = false
  }

  openValueChanged() {
    this.syncPanel()
  }

  syncPanel() {
    if (!this.hasPanelTarget) return

    if (this.openValue) {
      this.panelTarget.classList.add("opacity-0")
      if (this.hasDialogTarget) this.dialogTarget.classList.add("opacity-0", "scale-95")
      this.panelTarget.classList.remove("hidden")
      this.panelTarget.getBoundingClientRect()
      this.panelTarget.classList.remove("opacity-0")
      if (this.hasDialogTarget) this.dialogTarget.classList.remove("opacity-0", "scale-95")
      document.body.style.overflow = "hidden"
      document.addEventListener("keydown", this.handleKeydown)
    } else {
      if (this.panelTarget.classList.contains("hidden")) return
      this.panelTarget.classList.add("opacity-0")
      if (this.hasDialogTarget) this.dialogTarget.classList.add("opacity-0", "scale-95")
      this.panelTarget.addEventListener("transitionend", () => {
        this.panelTarget.classList.add("hidden")
        this.panelTarget.classList.remove("opacity-0")
        if (this.hasDialogTarget) this.dialogTarget.classList.remove("opacity-0", "scale-95")
      }, { once: true })
      document.body.style.overflow = ""
      document.removeEventListener("keydown", this.handleKeydown)
    }
  }
}
